import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ol>
      <li parentName="ol">{`Create a directory for your GraphQL files: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/main/graphql/com/example/`}</code></li>
      <li parentName="ol">{`Add your `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`schema.json`}</code>{` to the directory: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/main/graphql/com/example/schema.json`}</code></li>
      <li parentName="ol">{`Put your query in a `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`.graphql`}</code>{` file, next to the schema: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`src/main/graphql/com/example/LaunchDetails.graphql`}</code></li>
    </ol>
    <div {...{
      "className": "gatsby-code-title"
    }}>{`src/main/graphql/com/example/LaunchDetails.graphql`}</div>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "graphql"
    }}><pre parentName="div" {...{
        "style": {
          "counterReset": "linenumber NaN"
        },
        "className": "language-graphql line-numbers"
      }}><code parentName="pre" {...{
          "className": "language-graphql"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`query`}</span>{` LaunchDetails`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token variable"
          }}>{`$id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{`ID`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  launch`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token attr-name"
          }}>{`id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$id`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    id
    site
    mission `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      name
      missionPatch`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token attr-name"
          }}>{`size`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span><span parentName="code" {...{
            "className": "token constant"
          }}>{`LARGE`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code><span parentName="pre" {...{
          "aria-hidden": "true",
          "className": "line-numbers-rows",
          "style": {
            "whiteSpace": "normal",
            "width": "auto",
            "left": "0"
          }
        }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Build your project, this will generate the model`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      